import type { FC } from 'react';
import { useTranslation, Trans } from 'react-i18next';
import { useContext } from 'react';
import { SessionContext } from '@wix/da-react-context/pkg/publicSession';
import StandardMenu from '@wix/da-ds/pkg/Dropdown/MenuPreset/StandardMenu';
import { useBatchSellAction } from '../BatchSellGhostButton/useBatchSellAction';

const BatchSellSubmenu: FC = () => {
  const { t } = useTranslation();
  const { hasCoreMembership } = useContext(SessionContext);
  const { handlePartialSelect, isOverMaxSellLimit } = useBatchSellAction();

  if (!hasCoreMembership || !isOverMaxSellLimit) {
    return null;
  }

  return (
    <StandardMenu
      id="batch-sell-submenu"
      items={[
        {
          items: [
            {
              label: (
                <Trans i18nKey="studio.table.header.sell.tooltip">
                  You can sell a maximum
                  <br />
                  of 25 items at once
                </Trans>
              ),
              disabled: true,
            },
          ],
        },
        {
          items: [
            {
              label: t('studio.table.header.sell.option.first25'),
              onClick: () => handlePartialSelect('first'),
            },
            {
              label: t('studio.table.header.sell.option.last25'),
              onClick: () => handlePartialSelect('last'),
            },
          ],
        },
      ]}
    />
  );
};

BatchSellSubmenu.displayName = 'BatchSellSubmenu';

export default BatchSellSubmenu;
